<div class="app-c-rating-group" [ngClass]="customClass">
<label class="app-c-rating-option" *ngFor="let value of options">
  <input
    class="app-c-rating-input"
    type="radio"
    [name]="name"
    [value]="value"
    [checked]="value === checkedValue"
    [disabled]="disabled"
    (change)="onRadioChange($event)"
  />
  <span class="checkmark"></span>
  <span class="app-c-rating-label">{{ value }}</span>
</label>
</div>
<div class="app-c-rating-footer" *ngIf="showFooter">
  <span class="app-c-rating-indication">
    <sra-svg-icons
      name="dislike"
      title="Poor"
      className="icon-size-12"
      ariaHidden="false"
      focusable="false"
    />
    Poor
  </span>
  <span class="app-c-rating-indication">
    <sra-svg-icons
      name="like"
      title="Excellent"
      className="icon-size-12"
      ariaHidden="false"
      focusable="false"
    />

    Excellent
  </span>
</div>
